export const validateName = (name: string) => {
  const names = name.split(" ");

  if (names.length > 2) {
    return false;
  }

  let result = true;

  for (let i = 0; i < names.length; i++) {
    if (names[i].length > 14) {
      result = false;
      break;
    }
  }

  return result;
};
